export const JOB_PATH = job => {
  return `https://heyremote.io/job/${job.id}-${purifyTextForURL(
    job?.title
  )}-${purifyTextForURL(job?.company?.name)}`;
};
export const PAID_JOBS_PATH = "/jobs/view-paid-jobs";
export const ALL_JOBS_PATH = "/jobs/view-jobs";
// export const RESOURCE_PATH = `/resources/${}`;

const purifyTextForURL = text => {
  const filterLettersAndNumbers = text.replace(/[^a-zA-Z0-9]/g, "-");
  return filterLettersAndNumbers.replace(/(-)\1+/g, "$1");
};

// const purifyTextForURL = text => {
//   const withoutForwardSlash = removeForwardSlash(text);
//   const withoutRoundBrackets = removeRoundBrackets(withoutForwardSlash);
//   return removeComma(withoutRoundBrackets)
//     .split(" ")
//     .join("-");
// };

// const removeRoundBrackets = text => {
//   let left = text?.split("(").join("");
//   return left?.split(")").join("");
// };
// const removeForwardSlash = text => text?.split("/").join("-");
// const removeComma = text => text.split(",").join("");
